import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ColumnaConfig, TablaConfig} from "./tabla-config";
import {MatTableDataSource} from "@angular/material/table";

@Component({
  selector: 'lib-tabla-page',
  templateUrl: './tabla-page.component.html',
  styleUrls: ['./tabla-page.component.css']
})
export class TablaPageComponent<M> implements OnInit {

  @Input() config: TablaConfig;
  @Output() actionTrigger: EventEmitter<Record<string, M>> = new EventEmitter<Record<string, M>>();
  @Input() dataSource: MatTableDataSource<M>;


  public displayedColumns: string[];
  public loadTemplate = false;

  constructor() {
  }

  ngOnInit() {
    this.displayedColumns = this.config.columns.map((column: ColumnaConfig) => column.title);
    if (this.config.actions.length > 0) {
      this.displayedColumns.push('acciones');
    }
      if (this.config.chips && this.config.chips.length > 0) {
          this.displayedColumns.push('chips');
      }
    this.loadTemplate = true;
  }

  onAction = (evento: string, data: M) => {
    const res: Record<string, M> = {};
    res[evento] = data;
    this.actionTrigger.emit(res);
  }
}
